import React, { useState } from "react";
import "./BusinessIndustry.css";
import img1 from '../businessassets/industry1.png';
import img2 from '../businessassets/industry2.jpg';
import img3 from '../businessassets/industry3.jpg';
import img4 from '../businessassets/industry4.png';
import img5 from '../businessassets/industry5.jpg';
import img6 from '../businessassets/industry6.png';
import img7 from '../businessassets/industry7.jpg';
import img8 from '../businessassets/industry8.png';

export default function BusinessIndustry() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      img: img1,
      id: 1,
      title: "Assessment",
      description:
        "Streamline your Azure DevOps infrastructure by automating CI/CD pipelines and running continuous tests right from the start of the software development lifecycle",
    },
    {
      img: img2,
      id: 2,
      color:"black",
      title: "Proposal",
      description:
        "Integrate your AWS DevOps development process with best-in-class automation tools to reduce potential bugs and create robust cloud applications",
    },
    {
      img: img5,
      id: 3,
      title: "Due Diligence",
      description:
        "Cut down the scope of human intervention so that you can decrease the number of possible errors by thoroughly automating your build and deployment process",
    },
    {
      img: img3,
      id: 4,
      title: "Contract Procurement",
      description:
        "Embrace DevOps automation best practices and strategies to facilitate an efficient workflow in your business and reduce manual, time-consuming workload",
    },
    {
      img: img6,
      id: 5,
      color:"black",
      title: "Implementation",
      description:
        "Simplify your development tasks and make the entire ecosystem faster and more productive by enabling comprehensive DevOps process automation",
    },
    {
      img: img8,
      id: 6,
      color:"black",
      title: "Management",
      description:
        "Take your deployment and release game to new heights with the required speed, agility, and reliability through a continuous delivery automation plan",
    },
     {
      img: img4,
      id: 7,
      title: "Management",
      description:
        "Take your deployment and release game to new heights with the required speed, agility, and reliability through a continuous delivery automation plan",
    },
     {
      img: img7,
      id: 8,
      title: "Management",
      description:
        "Take your deployment and release game to new helpss with Zthe required speed, agility, and reliability through a continuous delivery automation plan",
    },
  ];

  return (
    <div id="business-industry" className="outsourcemainclass">
      <div className="top">
        <h2 className="heading">
         Computer Vision Solutions for Diverse Industries
        </h2>
        <p className="subheading">
          Our DevOps engineers automate deployments using workflow and test
          automation to improve efficiency, reliability, and collaboration
          across the DevOps lifecycle.{" "}
        </p>
      </div>
      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
           <div className="image">
             <img src={card.img} alt="error" />
            <div className="overlay"></div>
           </div>
            <h3 style={{color:card.color}}>{card.title}</h3>
         </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <img src={card.img} alt="error" />
                <h3>{card.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
